import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const ConfigurationNokiaExportRequest = (values) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}CM/ConfigurationNokiaExport`,
	data: values
});

export const ConfigurationHuaweiExportRequest = (values) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}CM/ConfigurationHuaweiExport`,
	data: values
});

export const GetLastDumpsUpdateRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}CM/GetLastDumpsUpdate`,
});
